/* import jwtDecode from 'jwt-decode'; */
import Cookies from 'js-cookie';
import { setUserCookie, userCookieName } from '../../utils/setUserCookie';
const logoutState = {
  login_status: false
};
const errorState = {
  login_status: true,
  error: true
};
// Check if user has logged in returns cookie if its not expired
// if expired it fetches new token else return current token
// if gets successfully then set new token to cookie and returns it.
export const getLatestUserCookie = (identityGlobal, clientId, clientSecret) => {
  return new Promise(resolve => {
    let cookie = getUserCookie();
    let socialPlatform = '';
    if (cookie.social_platform) {
      socialPlatform = cookie.social_platform;
    }
    if (cookie.login_status) {
      const expired = isSessionExpired(cookie);
      if (expired) {
        updateUserSession(cookie, identityGlobal, clientId, clientSecret).then(response => {
          if (response.access_token) {
            return resolve(setUserCookie(response, socialPlatform));
          } else {
            return resolve(response);
          }
        });
      } else {
        return resolve(cookie);
      }
    } else {
      return resolve(logoutState);
    }
  });
};

// return updated cookie regardless of expired or not
export const getUpdatedUserCookie = (identityGlobal, clientId, clientSecret) => {
  return new Promise(resolve => {
    let cookie = getUserCookie();
    let socialPlatform = '';
    if (cookie.social_platform) {
      socialPlatform = cookie.social_platform;
    }
    if (cookie.login_status) {
      updateUserSession(cookie, identityGlobal, clientId, clientSecret).then(response => {
        if (response.access_token) {
          return resolve(setUserCookie(response, socialPlatform));
        } else {
          return resolve(response);
        }
      });
    } else {
      return resolve(logoutState);
    }
  });
};

// return current user cookie.
export const getUserCookie = () => {
  let parsedCookie,
    status = false;
  const cookie = Cookies.get(userCookieName);
  if (cookie) {
    try {
      parsedCookie = JSON.parse(cookie || '');
      if (parsedCookie.access_token) {
        status = true;
      }
    } catch (e) {}
  }
  if (status) {
    return parsedCookie;
  }
  return logoutState;
};

/* const jwtDecodeInternal = (token: any) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    return logoutState;
  }
}; */

/* export const getJWTCookie = (cookie: any) => {
  return jwtDecodeInternal(cookie.access_token);
}; */

/* export const getJWT = (param: any) => {
  if (param.access_token) {
    return jwtDecodeInternal(param.access_token);
  } else {
    return jwtDecodeInternal(param);
  }
}; */

//
// Internal Functions
//

// Delete Cookie
export const deleteUserCookie = () => {
  const cookie = Cookies.get(userCookieName);
  if (cookie) {
    Cookies.remove(userCookieName);
  }
};

// Logout user
export const logoutUser = (identityGlobal, clientId, clientSecret) => {
  return new Promise(function (resolve) {
    const cookie = getUserCookie();

    // dont procede if no access_token or refresh_token in cookie
    if (!(cookie.refresh_token && cookie.access_token)) {
      resolve(false);
    }
    let myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${cookie.access_token}`);
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    let urlencoded = new URLSearchParams();
    urlencoded.append('token', cookie.refresh_token);
    urlencoded.append('token_type_hint', 'refresh_token');
    urlencoded.append('client_id', clientId);
    urlencoded.append('client_secret', clientSecret);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };
    let statusCode = 0;
    fetch(`${identityGlobal}/connect/revocation`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }).then(result => {
      let responseObj;
      if (result && result.length) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (!result.length) {
          deleteUserCookie();
          resolve(true);
        } else {
          throw new Error('Could not logout');
        }
      } else {
        throw new Error('Could not logout');
      }
    }).catch(error => {
      resolve(false);
    });
  });
};

// to fetch new token through refresh token
export const updateUserSession = (cookie, identityGlobal, clientId, clientSecret) => {
  let urlencoded = new URLSearchParams();
  urlencoded.append('grant_type', 'refresh_token');
  urlencoded.append('client_id', clientId);
  urlencoded.append('client_secret', clientSecret);
  urlencoded.append('scope', 'api.read    IdentityServerApi   offline_access');
  urlencoded.append('refresh_token', cookie.refresh_token);
  let myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
  let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow'
  };
  let statusCode = 0;
  return fetch(`${identityGlobal}/connect/token`, requestOptions).then(response => {
    statusCode = response.status;
    return response.text();
  }).then(result => {
    let responseObj;
    if (result) {
      responseObj = JSON.parse(result);
    }
    if (statusCode === 400) {
      if (responseObj.error) {
        throw Error(responseObj.error);
      }
    } else if (statusCode === 404) {
      throw Error('Invalid URL');
    } else if (statusCode === 200) {
      if (responseObj.access_token) {
        // setTimeout((responseObj) => {
        return responseObj;
        // }, 1000);
      }
    } else {
      throw Error(`Unknown error, status ${statusCode}`);
    }
  }).catch(error => {
    if (error.message === 'invalid_grant') {
      logoutUser(identityGlobal, clientId, clientSecret);
      return logoutState;
    } else {
      return errorState;
    }
  });
};

// check using time if token has expired
export const isSessionExpired = cookie => {
  const now = Date.now().valueOf() / 1000;
  const bufferSeconds = 60 * 7; // 7 seconds buffer before cookie expires
  const exp = cookie.expires_at - bufferSeconds;
  return now > exp;
};